/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, reset, getFormValues, initialize } from 'redux-form';
import { Icon, TextStyle, Link, Badge } from '@shopify/polaris';
import { ChevronLeftMinor, ChevronRightMinor, ExternalMinor } from '@shopify/polaris-icons';
import Classnames from 'classnames';
import { withI18n } from '@shopify/react-i18n';

import GeneralForm from 'src/components/views/shopify-integration-settings/form';
import {
  DEVICE,
  MENU_ITEM_VALUE,
  MENU_STYLES_OPTIONS,
  MENU_PRODUCT_ITEM_OPTIONS,
  MENU_PRODUCT_LIST_OPTIONS,
  MENU_ADVANCED_SETTINGS_OPTIONS,
  SIDEBAR_MENU
} from 'src/constants/theme-settings';
import { ReactComponent as IconColor } from 'src/assets/images/shopify-integration-settings/color.svg';
import { ReactComponent as IconTypography } from 'src/assets/images/shopify-integration-settings/typography.svg';
import { ReactComponent as IconTheme } from 'src/assets/images/shopify-integration-settings/themes.svg';
import { ReactComponent as IconDiscount } from 'src/assets/images/shopify-integration-settings/discounts.svg';
import { ReactComponent as IconBuyButton } from 'src/assets/images/shopify-integration-settings/buy-btn.svg';
import { ReactComponent as IconCashDollar } from 'src/assets/images/shopify-integration-settings/cash-dollar.svg';
import { ReactComponent as IconColorMinor } from 'src/assets/images/shopify-integration-settings/colors-minor.svg';
import { ReactComponent as IconInfo } from 'src/assets/images/shopify-integration-settings/info.svg';
import { ReactComponent as IconEye } from 'src/assets/images/shopify-integration-settings/eye.svg';
import { ReactComponent as IconHeader } from 'src/assets/images/shopify-integration-settings/header.svg';
import { ReactComponent as IconBreadcrumbs } from 'src/assets/images/shopify-integration-settings/breadcrumbs.svg';
import { ReactComponent as IconSection } from 'src/assets/images/shopify-integration-settings/section.svg';
import { ReactComponent as IconPagination } from 'src/assets/images/shopify-integration-settings/sidebar.svg';
import { ReactComponent as IconCart } from 'src/assets/images/shopify-integration-settings/cart.svg';
import { ReactComponent as IconQuestion } from 'src/assets/images/shopify-integration-settings/question-mark.svg';

import * as ShopifyIntegrationSettingsAction from 'src/stores/actions/shopify-integration/shopify-integration-settings-actions';

type Props = {};

type ComposedProps = Props & WithI18nProps;

type State = {};

class Menu extends Component<ComposedProps, State> {
  handleSelectMenu = menuItem => {
    const { sideBarMenu } = this.props;
    if (
      sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM ||
      sideBarMenu === SIDEBAR_MENU.ADVANCED_SETTINGS
    ) {
      return;
    }
    this.props.updateFieldReducer('activeMenuItem', menuItem.value);
  };

  handleBack = () => {
    const { activeMenuItem } = this.props;
    const isInSubSettingTypo = [
      MENU_ITEM_VALUE.TYPOGRAPHY_HEADING,
      MENU_ITEM_VALUE.TYPOGRAPHY_BODY,
      MENU_ITEM_VALUE.TYPOGRAPHY_BUTTON,
      MENU_ITEM_VALUE.TYPOGRAPHY_LINK_ACCENT
    ].includes(activeMenuItem);

    if (activeMenuItem === MENU_ITEM_VALUE.ADVANCED_COLOR) {
      this.props.updateFieldReducer('activeMenuItem', MENU_ITEM_VALUE.COLOR);
    } else if (isInSubSettingTypo) {
      this.props.updateFieldReducer('activeMenuItem', MENU_ITEM_VALUE.TYPOGRAPHY);
    } else {
      this.props.updateFieldReducer('activeMenuItem', '');
    }
  };

  getMenuInside = () => {
    const { i18n, sideBarMenu } = this.props;
    let menus = [];
    let mapIcon = {};
    if (sideBarMenu === SIDEBAR_MENU.STYLE) {
      mapIcon = {
        [MENU_ITEM_VALUE.COLOR]: IconColor,
        [MENU_ITEM_VALUE.TYPOGRAPHY]: IconTypography
      };
      menus = MENU_STYLES_OPTIONS.map(item => {
        return {
          ...item,
          label: i18n.translate(item.label)
        };
      });
    } else if (sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM) {
      mapIcon = {
        [MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT]: IconTheme,
        [MENU_ITEM_VALUE.PRODUCT_ITEM_LABEL]: IconDiscount,
        [MENU_ITEM_VALUE.PRODUCT_ITEM_PRICE]: IconCashDollar,
        [MENU_ITEM_VALUE.PRODUCT_ITEM_SWATCHES]: IconColorMinor,
        // [MENU_ITEM_VALUE.PRODUCT_ITEM_ADD_TO_CART_BTN]: IconBuyButton,
        // [MENU_ITEM_VALUE.PRODUCT_ITEM_QUICK_VIEW_BTN]: IconEye,
        [MENU_ITEM_VALUE.PRODUCT_ITEM_ADDITIONAL_INFO]: IconInfo,
        [MENU_ITEM_VALUE.PRODUCT_ITEM_CALL_TO_ACTION]: IconBuyButton
      };
      menus = MENU_PRODUCT_ITEM_OPTIONS.map(item => {
        return {
          ...item,
          label: i18n.translate(item.label)
        };
      });
    } else if (sideBarMenu === SIDEBAR_MENU.PRODUCT_LIST) {
      mapIcon = {
        [MENU_ITEM_VALUE.PRODUCT_LIST_LAYOUT]: IconTheme,
        [MENU_ITEM_VALUE.PRODUCT_LIST_COLLECTION_HEADER]: IconHeader,
        [MENU_ITEM_VALUE.PRODUCT_LIST_BREADCRUMBS]: IconBreadcrumbs,
        [MENU_ITEM_VALUE.PRODUCT_LIST_TOOLBAR]: IconSection,
        [MENU_ITEM_VALUE.PRODUCT_LIST_PAGINATION]: IconPagination
      };
      menus = MENU_PRODUCT_LIST_OPTIONS.map(item => {
        return {
          ...item,
          label: i18n.translate(item.label)
        };
      });
    } else if (sideBarMenu === SIDEBAR_MENU.ADVANCED_SETTINGS) {
      mapIcon = {
        [MENU_ITEM_VALUE.ADVANCED_SETTINGS_QUICK_VIEW]: IconEye,
        [MENU_ITEM_VALUE.ADVANCED_SETTINGS_AJAX_CART]: IconCart
      };
      menus = MENU_ADVANCED_SETTINGS_OPTIONS.map(item => {
        return {
          ...item,
          label: i18n.translate(item.label)
        };
      });
    }

    return {
      menus,
      mapIcon
    };
  };

  getTitle = () => {
    const { i18n, sideBarMenu, activeMenuItem } = this.props;
    let title = '';
    if (!activeMenuItem) {
      const MAP_TITLE = {
        [SIDEBAR_MENU.STYLE]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.MenuSettings.style'
        ),
        [SIDEBAR_MENU.PRODUCT_ITEM]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.MenuSettings.productItem'
        ),
        [SIDEBAR_MENU.PRODUCT_LIST]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.MenuSettings.productList'
        ),
        [SIDEBAR_MENU.ADVANCED_SETTINGS]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.MenuSettings.advancedSettings'
        )
      };
      title = MAP_TITLE[sideBarMenu];
    } else {
      const MAP_TITLE = {
        [MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.layout'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_LABEL]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.productLabel'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_PRICE]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.productPrice'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_SWATCHES]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.swatches'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_ADD_TO_CART_BTN]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.addToCartBtn'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_QUICK_VIEW_BTN]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.quickViewBtn'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_ADDITIONAL_INFO]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.additionalInfo'
        ),
        [MENU_ITEM_VALUE.PRODUCT_ITEM_CALL_TO_ACTION]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.callToAction'
        ),

        [MENU_ITEM_VALUE.PRODUCT_LIST_LAYOUT]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.layout'
        ),
        [MENU_ITEM_VALUE.PRODUCT_LIST_COLLECTION_HEADER]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.collectionHeader'
        ),
        [MENU_ITEM_VALUE.PRODUCT_LIST_BREADCRUMBS]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.breadcrumbs'
        ),
        [MENU_ITEM_VALUE.PRODUCT_LIST_TOOLBAR]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.toolbar'
        ),
        [MENU_ITEM_VALUE.PRODUCT_LIST_PAGINATION]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.pagination'
        ),

        [MENU_ITEM_VALUE.ADVANCED_SETTINGS_QUICK_VIEW]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.quickView'
        ),
        [MENU_ITEM_VALUE.ADVANCED_SETTINGS_AJAX_CART]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.cartSetting'
        ),

        [MENU_ITEM_VALUE.COLOR]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.colors'
        ),
        [MENU_ITEM_VALUE.ADVANCED_COLOR]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.MenuSettings.advancedSettings'
        ),
        [MENU_ITEM_VALUE.TYPOGRAPHY]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.typography'
        ),

        [MENU_ITEM_VALUE.TYPOGRAPHY_HEADING]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Heading'
        ),
        [MENU_ITEM_VALUE.TYPOGRAPHY_BODY]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Body'
        ),
        [MENU_ITEM_VALUE.TYPOGRAPHY_BUTTON]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Button'
        ),
        [MENU_ITEM_VALUE.TYPOGRAPHY_LINK_ACCENT]: i18n.translate(
          'AdminHTML.ShopifyIntegrationSettings.Setting.typography_LinkAccent'
        )
      };
      title = MAP_TITLE[activeMenuItem];
    }

    return title;
  };

  render() {
    const {
      i18n,
      isExpandFullscreen,
      sideBarMenu,
      activeMenuItem,
      formValues,
      // commonSetting,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
      labelTranslation,
      boostThemeLibName,
      filterDataOptions,
      currentAppReviewIntegration,
      updateFieldReducer,
      updateField
    } = this.props;
    const menuClass = Classnames('visual-editor-menu', {
      opened: !isExpandFullscreen
    });

    const { menus, mapIcon } = this.getMenuInside();
    const title = this.getTitle();

    const isRenderTooltipQuestion = [
      SIDEBAR_MENU.PRODUCT_ITEM,
      SIDEBAR_MENU.ADVANCED_SETTINGS
    ].includes(sideBarMenu);

    return (
      <div className={menuClass}>
        <div className="title-wrapper">
          <div className="menu-title">
            <h2>
              {activeMenuItem && (
                <span className="btn-back" onClick={this.handleBack}>
                  <Icon source={ChevronLeftMinor} />
                </span>
              )}
              <span>{title}</span>
              {isRenderTooltipQuestion && !activeMenuItem && (
                // TODO: update tooltip content
                <div
                  className="tooltip-icon"
                  data-for="menu-question"
                  data-tip={
                    sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM ? 'Product item' : 'Advanced settings'
                  }>
                  <IconQuestion />
                  <ReactTooltip id="menu-question" place="right" effect="solid" type="light" />
                </div>
              )}
            </h2>

            {(sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM ||
              sideBarMenu === SIDEBAR_MENU.ADVANCED_SETTINGS) && (
              <Badge status="info">
                {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Common.comingSoon')}
              </Badge>
            )}
          </div>

          {sideBarMenu === SIDEBAR_MENU.PRODUCT_LIST && !activeMenuItem && (
            <div className="product-guide">
              <span className="form-link">
                <TextStyle variation="subdued">
                  {i18n.translate('AdminHTML.ThemeSetting.Form.productList_UserGuide')}
                </TextStyle>{' '}
                <Link url={URL['ProductListThemeSetting']} external>
                  {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Common.clickHere')}
                  <Icon source={ExternalMinor} color="base" />
                </Link>
                <span style={{ color: '#2C6ECB' }}>.</span>
              </span>
            </div>
          )}

          {(sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM ||
            sideBarMenu === SIDEBAR_MENU.ADVANCED_SETTINGS) && (
            <div className="product-guide">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Setting.comingSoon_Content')}
              </TextStyle>
            </div>
          )}
        </div>

        {!activeMenuItem ? (
          <div
            className={Classnames('menu-container', {
              disabled:
                sideBarMenu === SIDEBAR_MENU.PRODUCT_ITEM ||
                sideBarMenu === SIDEBAR_MENU.ADVANCED_SETTINGS
            })}>
            {menus.map((item, index) => {
              const MenuIcon = mapIcon[item.value];
              return (
                <div
                  className="menu-container__item"
                  onClick={() => this.handleSelectMenu(item)}
                  key={index}>
                  <div className="menu-container__item__name">
                    <MenuIcon />
                    <span>{item.label}</span>
                  </div>
                  <Icon source={ChevronRightMinor} />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="form-container">
            <GeneralForm
              activeMenuItem={activeMenuItem}
              updateField={updateField}
              formValues={formValues}
              filterDataOptions={filterDataOptions}
              currentAppReviewIntegration={currentAppReviewIntegration}
              themeSettingDefaultValue={themeSettingDefaultValue}
              themeSettingDefaultThemeValue={themeSettingDefaultThemeValue}
              labelTranslation={labelTranslation}
              boostThemeLibName={boostThemeLibName}
              updateFieldReducer={updateFieldReducer}
              pagination
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateField: (field, value) =>
    dispatch(change(`ShopifyIntegrationSettingsVisualEditorForm`, field, value)),
  resetForm: () => dispatch(reset('ShopifyIntegrationSettingsVisualEditorForm')),
  initialize: data => dispatch(initialize('ShopifyIntegrationSettingsVisualEditorForm', data)),

  updateFieldReducer: (fieldName, data) =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateField(fieldName, data)),
  updateMultiFieldsReducer: data =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateMultiFields(data))
});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('ShopifyIntegrationSettingsVisualEditorForm')(state) || {};
  const isExpandFullscreen =
    _.get(state, 'shopifyIntegrationSettings.device') === DEVICE.FULLSCREEN;
  const filterDataOptions = _.get(state.filterData.filterData, 'optionsList', []);
  const currentAppReviewIntegration = _.get(
    state.oauth.tenantApp,
    'currentAppReviewIntegration',
    ''
  );
  return {
    formValues,
    isExpandFullscreen,
    sideBarMenu: _.get(state, 'shopifyIntegrationSettings.sideBarMenu', ''),
    activeMenuItem: _.get(state, 'shopifyIntegrationSettings.activeMenuItem', ''),
    // commonSetting: _.get(state, 'shopifyIntegrationSettings.commonSetting', []),
    themeSettingDefaultValue: _.get(
      state,
      'shopifyIntegrationSettings.themeSettingDefaultValue',
      {}
    ),
    themeSettingDefaultThemeValue: _.get(
      state,
      'shopifyIntegrationSettings.themeSettingDefaultThemeValue',
      {}
    ),
    labelTranslation: _.get(state, 'shopifyIntegrationSettings.labelTranslation', {}),
    // themeName: props.themeName,
    boostThemeLibName: _.get(state, 'shopifyIntegrationSettings.boostThemeLibName', 'default'),
    filterDataOptions,
    currentAppReviewIntegration
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Menu));
